import type { SmartCalcColumnId as ColumnId } from '../calcStack';
import { COL } from '../columns';
import type { SmartPricingRow } from '../smartRow';

// COL keys are exactly the SmartPricingRow field names that accept cascade patches.
// Membership in this set is the checked narrowing from SmartCalcColumnId to
// a concrete keyof SmartPricingRow.
const ROW_FIELD_KEYS = new Set<string>(Object.keys(COL));
// Compile-time invariant: every key of COL is a key of SmartPricingRow, so the
// membership-checked `as keyof SmartPricingRow` narrowing in toRowFieldKey is sound.
type _AssertColKeysAreRowFields = keyof typeof COL extends keyof SmartPricingRow ? true : never;

export const toRowFieldKey = (id: ColumnId): keyof SmartPricingRow | undefined =>
  ROW_FIELD_KEYS.has(id) ? (id as unknown as keyof SmartPricingRow) : undefined;

// Checked read mirror of the write-side narrowing: routes a cell read through
// toRowFieldKey so unknown column ids return undefined rather than require an unsafe cast.
export const readRowField = (
  row: SmartPricingRow,
  columnId: ColumnId,
): SmartPricingRow[keyof SmartPricingRow] | undefined => {
  const key = toRowFieldKey(columnId);
  return key === undefined ? undefined : row[key];
};
